// Tailwind class helpers + libellés FR pour les badges du module Support.
// Le fallback (rouge) est intentionnel : toute valeur hors du set connu doit
// ressortir visuellement comme une anomalie pour l'admin (cf. subscriptionBadge).

const FALLBACK_COLOR = "bg-red-100 text-red-800";

// ---------------------------------------------------------------------------
// Statut du ticket
// ---------------------------------------------------------------------------
const STATUS_COLORS: Record<string, string> = {
  open: "bg-blue-100 text-blue-800",
  pending: "bg-yellow-100 text-yellow-800",
  on_hold: "bg-orange-100 text-orange-800",
  solved: "bg-green-100 text-green-800",
  closed: "bg-gray-100 text-gray-700",
};

const STATUS_LABELS: Record<string, string> = {
  open: "Ouvert",
  pending: "En attente",
  on_hold: "En pause",
  solved: "Résolu",
  closed: "Clôturé",
};

export function ticketStatusColor(status: string | null | undefined): string {
  if (!status) return FALLBACK_COLOR;
  return STATUS_COLORS[status] ?? FALLBACK_COLOR;
}

export function ticketStatusLabel(status: string | null | undefined): string {
  if (!status) return "inconnu";
  return STATUS_LABELS[status] ?? status;
}

// ---------------------------------------------------------------------------
// Priorité du ticket
// ---------------------------------------------------------------------------
const PRIORITY_COLORS: Record<string, string> = {
  low: "bg-gray-100 text-gray-700",
  normal: "bg-blue-100 text-blue-800",
  high: "bg-orange-100 text-orange-800",
  urgent: "bg-red-100 text-red-800",
};

const PRIORITY_LABELS: Record<string, string> = {
  low: "Basse",
  normal: "Normale",
  high: "Haute",
  urgent: "Urgente",
};

export function ticketPriorityColor(priority: string | null | undefined): string {
  if (!priority) return FALLBACK_COLOR;
  return PRIORITY_COLORS[priority] ?? FALLBACK_COLOR;
}

export function ticketPriorityLabel(priority: string | null | undefined): string {
  if (!priority) return "inconnue";
  return PRIORITY_LABELS[priority] ?? priority;
}

// ---------------------------------------------------------------------------
// Catégorie du ticket
// ---------------------------------------------------------------------------
const CATEGORY_COLORS: Record<string, string> = {
  question: "bg-cyan-100 text-cyan-800",
  billing: "bg-purple-100 text-purple-800",
  bug: "bg-rose-100 text-rose-800",
  feature_request: "bg-teal-100 text-teal-800",
  account: "bg-blue-100 text-blue-800",
  refund: "bg-amber-100 text-amber-800",
  other: "bg-gray-100 text-gray-700",
};

const CATEGORY_LABELS: Record<string, string> = {
  question: "Question",
  billing: "Facturation",
  bug: "Bug",
  feature_request: "Suggestion",
  account: "Compte",
  refund: "Remboursement",
  other: "Autre",
};

export function ticketCategoryColor(category: string | null | undefined): string {
  if (!category) return FALLBACK_COLOR;
  return CATEGORY_COLORS[category] ?? FALLBACK_COLOR;
}

export function ticketCategoryLabel(category: string | null | undefined): string {
  if (!category) return "inconnue";
  return CATEGORY_LABELS[category] ?? category;
}

// ---------------------------------------------------------------------------
// Statut d'une demande de remboursement
// ---------------------------------------------------------------------------
const REFUND_COLORS: Record<string, string> = {
  requested: "bg-yellow-100 text-yellow-800",
  approved: "bg-green-100 text-green-800",
  rejected: "bg-red-100 text-red-800",
  processing: "bg-blue-100 text-blue-800",
  refunded: "bg-green-100 text-green-800",
  failed: "bg-red-100 text-red-800",
};

const REFUND_LABELS: Record<string, string> = {
  requested: "En attente",
  approved: "Approuvée",
  rejected: "Refusée",
  processing: "En traitement",
  refunded: "Remboursée",
  failed: "Échec",
};

export function refundStatusColor(status: string | null | undefined): string {
  if (!status) return FALLBACK_COLOR;
  return REFUND_COLORS[status] ?? FALLBACK_COLOR;
}

export function refundStatusLabel(status: string | null | undefined): string {
  if (!status) return "inconnu";
  return REFUND_LABELS[status] ?? status;
}
